module.exports = __webpack_public_path__ + "img/small-5.30b34991.webp";